import type { DailyTaskDefaultFilters, User } from '../../../types';
import type { DailyTasksFormFilerValue } from './types';

export function transformFilterForBackend({
  filters,
  currentUser,
}: {
  filters: DailyTasksFormFilerValue;
  currentUser: User;
}): DailyTaskDefaultFilters {
  const {
    startDate,
    endDate,
    responsible,
    userFunctions,
    status,
    participants,
    typeDate,
    resolutionLevel,
    isAssignedToMe,
    locations,
  } = filters;

  return {
    startDate: startDate ?? undefined,
    endDate: endDate ?? undefined,
    typeDate,
    status: status?.map((item) => item),
    responsible: responsible?.map((item) => item.id),
    userFunctions: userFunctions?.map((item) => item.id),
    participants: participants?.map((item) => item.id),
    resolutionLevel: resolutionLevel?.map((item) => item),
    locations: locations?.map((item) => item.id),
    isAssignedToMe: isAssignedToMe ?? false,
    ...(isAssignedToMe && currentUser ? { responsible: [currentUser.id] } : {}),
  };
}
